/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBusinessMarketplaceFeeBody
 */
export interface UpdateBusinessMarketplaceFeeBody {
    /**
     * 
     * @type {number}
     * @memberof UpdateBusinessMarketplaceFeeBody
     */
    marketplacePercentageDelivery?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBusinessMarketplaceFeeBody
     */
    marketplacePercentagePickup?: number;
}

export function UpdateBusinessMarketplaceFeeBodyFromJSON(json: any): UpdateBusinessMarketplaceFeeBody {
    return UpdateBusinessMarketplaceFeeBodyFromJSONTyped(json, false);
}

export function UpdateBusinessMarketplaceFeeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBusinessMarketplaceFeeBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'marketplacePercentageDelivery': !exists(json, 'marketplacePercentageDelivery') ? undefined : json['marketplacePercentageDelivery'],
        'marketplacePercentagePickup': !exists(json, 'marketplacePercentagePickup') ? undefined : json['marketplacePercentagePickup'],
    };
}

export function UpdateBusinessMarketplaceFeeBodyToJSON(value?: UpdateBusinessMarketplaceFeeBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'marketplacePercentageDelivery': value.marketplacePercentageDelivery,
        'marketplacePercentagePickup': value.marketplacePercentagePickup,
    };
}


